import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { MenuCardSubLabel } from "../menu/MenuCardSubLabel";
import { Input } from "../editor/Input";
import { SoundSelectionButton } from "../action/selector/SoundSelectionButton";
import { SoundCache } from "../../stores/SoundCache";
import { editorStore } from "../../stores/EditorStore";
import { mainMapEditorStore } from "../../stores/MapEditorStore";
const MarginContainer = styled.div.withConfig({
  displayName: "MapSettingsComponent__MarginContainer",
  componentId: "sc-76gal5-0"
})(["margin-left:8px;"]);
export const MapSettingsComponent = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    currentMap
  } = mainMapEditorStore.currentMapStore;

  const toggleShouldShowWater = () => {
    currentMap.properties.setShouldShowWater(!currentMap.properties.shouldShowWater);
  };

  if (!currentMap) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuCardSubLabel, null, t("editor.map_settings")), /*#__PURE__*/React.createElement(MarginContainer, null, /*#__PURE__*/React.createElement("label", null, t("editor.show_water_on_map"), /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    checked: currentMap.properties.shouldShowWater,
    onChange: toggleShouldShowWater
  }))), /*#__PURE__*/React.createElement(MarginContainer, null, /*#__PURE__*/React.createElement(SoundSelectionButton, {
    onSelectSoundPath: path => currentMap.properties.setBackgroundSoundFilePath(path),
    selectedPath: currentMap.properties.backgroundSoundFilePath,
    filterForSoundPrefix: [SoundCache.LEVEL_BACKGROUND_PREFIX],
    text: t("editor.map_background_sound"),
    allowBlankValue: true
  })), /*#__PURE__*/React.createElement(MarginContainer, null, t("editor.map_name"), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: currentMap.properties.name,
    onChange: e => currentMap.properties.setName(e.target.value)
  })), editorStore.isMainGameEditor && /*#__PURE__*/React.createElement(MarginContainer, null, t("editor.map_sorting_priority"), /*#__PURE__*/React.createElement(Input, {
    type: "number",
    step: 1,
    value: currentMap.properties.sortingPriority,
    onChange: e => currentMap.properties.setSortingPriority(+e.target.value)
  })));
});